import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // ⬅️ Import useNavigate
import "./cashwalletpage.css";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory";
import bankicon from "../../images/shapes/bank-pound-icon2 4.png";
import Footer from "../../components/footer/Footer";
import wallet from "../../images/shapes/Group 461.png"
import LoginHeader from "../../components/header/Loginheader";
import { API_URL } from "../../constant";

const CashWallet = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const navigate = useNavigate(); // ⬅️ Initialize navigate

  // Fetch transactions and balance from backend on component mount
  useEffect(() => {
    const fetchWalletData = async () => {
      try {
        const token = localStorage.getItem("auth_token");

        if (!token) {
          throw new Error("User is not authenticated. No token found.");
        }

        console.log("🔐 Sending request with token:", `Bearer ${token}`);

        const response = await fetch(`${API_URL}/api/wallet`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const contentType = response.headers.get("content-type");
        const isJson = contentType && contentType.includes("application/json");

        if (!response.ok) {
          const errorData = isJson
            ? await response.json()
            : await response.text();
          console.error("❌ API error response:", errorData);

          const message = isJson
            ? errorData.message || "Failed to fetch wallet data"
            : `Error ${response.status}: ${response.statusText}`;
          throw new Error(message);
        }

        const data = await response.json();
        setTransactions(data.transactions || []);
        setBalance(data.points || 0);
      } catch (error) {
        console.error("🚨 Error fetching wallet data:", error.message);
      }
    };

    fetchWalletData();
  }, []);

  // Navigate to /cashwallet on button click
  const handleTCWalletClick = () => {
    navigate("/customer/wallet"); // ⬅️ Navigate to the page
  };

  // Handle request conversion
  const handleRequestClick = () => {
    if (balance < 20000) {
      alert("This feature will be available once you reach 20,000 TopCoins.");
    } else {
      alert("Conversion process started!");
      // Add your real logic here
    }
  };

  return (
  <div>
    <LoginHeader/>
    <div className="wallet-container">
      <div className="wallet-left">
        <div className="wallet-left-text">
          <h2 className="highlight">TopCoin Cash Wallet</h2>
          <p className="balance-label">Available Balance</p>
          <h1 className="balance-value"> £ {balance} </h1>
        </div>

        <div className="bank-request">
          <p className="convert-text">Convert your TopCoins into cash</p>
          <img className="bank-icon" src={bankicon} alt="bankicon" />
          <button
            className={balance >= 20000 ? "active-button" : "disabled-button"}
            onClick={handleRequestClick}
          >
            Request 
          </button>
        </div>

        <button className="wallet-button" onClick={handleTCWalletClick}>
  TC TopCoins Wallet
  <img src={wallet} alt="wallet icon" className="wallet-icon" />
</button>

      </div>

      <div className="wallet-right">
        <TransactionHistory />
        {transactions.map((t) => (
          <div className="transaction-row" key={t.id}>
            <span>{t.id}</span>
            <span>{t.name}</span>
            <span>{t.date}</span>
            <span className={t.points.includes("-") ? "negative" : "positive"}>
              {t.points} TopCoins
            </span>
          </div>
        ))}
      </div>
      
    </div>
    <Footer/>
    </div>
  );
};

export default CashWallet;
